import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SEO";
import "./About.css";

export default function About() {

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="about-page">
      <SEO title="About" path="/about" description="Learn about LawFusion — an AI-powered legal analysis platform built for solo practitioners and small law firms." />
      <Header />
      <div className="about-layout">
        <main className="about-wrapper about-wrapper-no-sidebar">
          <section className="about-content">
            <div className="about-story-label">OUR STORY</div>

            <h1 className="about-title">
              LawFusion was inspired by firsthand experience with complex litigation.
            </h1>

            <p className="about-paragraph about-intro">
              I was the lead plaintiff in Singh v. Google Inc., Case No. 5:16-cv-03734 (N.D. Cal.), a class action involving alleged invalid clicks on Google&apos;s advertising platform.
            </p>

            <p className="about-paragraph">
              The case involved years of litigation, extensive legal analysis, and an appeal to the Ninth Circuit. Our attorneys worked collaboratively throughout the case, challenging arguments, refining strategy, and successfully overturning an earlier dismissal on appeal. Ultimately, the court declined to certify the proposed class.
            </p>

            <p className="about-paragraph">
              That experience gave me a firsthand view of how strong legal arguments are developed: they are tested, debated, and examined from multiple perspectives before being presented to a court.
            </p>

            <p className="about-paragraph">
              It also led to a simple question:
            </p>

            <p className="about-paragraph about-emphasis">
              Could technology give solo and small-firm attorneys a more structured way to pressure-test their arguments before filing?
            </p>

            <p className="about-paragraph">
              That question became LawFusion.
            </p>

            <p className="about-paragraph">
              Through its Debate Mode and Research Mode, LawFusion helps attorneys compare perspectives, identify vulnerabilities, anticipate counterarguments, and strengthen their legal reasoning.
            </p>

            <p className="about-paragraph about-emphasis">
              LawFusion does not replace legal judgment. It is designed to help attorneys examine their work more critically before opposing counsel does.
            </p>

            <div className="about-signature">
              <p>— Gurminder Singh</p>
              <p>Founder, LawFusion</p>
            </div>
          </section>
        </main>
      </div>

      <Footer className="about-page-footer" />
    </div>
  );
}

